<template>
    <div class="container-principal">
        <div class="container-card d-flex flex-row flex-wrap justify-content-start">
            <CardMachines
            v-for="data in listaPrensa"
            :key="data.id"
            :texto-header="`${data.nome} | ${data.offline ? 'Offline' : 'Online'}`"
            :voltagem-rastreador="data.lastStatusReport.bck_volt"
            :voltagem-caminhao="data.lastStatusReport.pwr_volt"
            :data-modulo="data.lastStatusReport.date_module"
            :messageError="data.problems"
            :is-erro="data.problems.length > 0"
            :is-online="data.offline ? false : true"
            :latitude="data.lastStatusReport.lat"
            :longitude="data.lastStatusReport.lon"
            :statusReport="data.identificador_localizacao"
            />
        </div>
    </div>
</template>

<script>
	import CardMachines from "../components/CardMachines.vue";
	import { FetchMachineList} from "../services/machine";

	export default {
		name: "MachinesPage",
		components: {
			CardMachines
		},
		data () {
			return {
				statusCode: 418,
				listaPrensa: []

			};
		},
		methods: {
			async machineList () {
				const data = await FetchMachineList();
				this.statusCode = data.statusCode;
				this.listaPrensa = data.listaPrensa ?? [];
			}
		},
		mounted () {
			this.machineList();

			this.refresh = setInterval(() => {
				this.machineList();

			}, 30000);
		},

		beforeDestroy () {
			clearInterval(this.refresh);
		}
	};



</script>

<style scoped>
:deep(.textoCardClassProps) {
    font-size: 11px;
}

.container-principal {
   width: 100%;
    overflow-y: scroll;


}

.container-card {
    padding: 1.5em;
    box-sizing: border-box;
    max-width: 100%;
    gap: 0.25em;
    margin: 0 0 0 70px ;
}



</style>